import { ItiString } from "../utils/iti-string";

export class ItiBaseDto {
	public id: any = null;
	public version!: any;
	protected originalJson: string = ItiString.Empty;

	constructor(src?: any, enableTrackChanges = false) {
		this.copy(src);

		if (enableTrackChanges) {
			this.resetTrackChanges();
		}
	}

	public copy(src?: any) {
		if (src) {
			Object.assign(this, src);
		}
	}

	public isNewItem(): boolean {
		return !!(!this.id || this.id === 0);
	}

	public isChanged(): boolean {
		if (this.originalJson != null) {
			const currentJson = JSON.stringify(this.omitKeys(this, ["originalJson"]));
			return currentJson !== this.originalJson;
		}
		return false;
	}

	public fromJson(data: string) {
		if (data) {
			const object = JSON.parse(data);
			Object.assign(this, object);
		}
	}

	public toJson(omitProperties: string[] = [], resetTrackChanges = true) {
		omitProperties.push("originalJson");
		if (
			omitProperties.indexOf("id") === -1 &&
			(this.id === null || this.id === undefined)
		) {
			omitProperties.push("id");
		}
		const jsonData = this.omitKeys(this, omitProperties);

		if (resetTrackChanges) {
			this.originalJson = JSON.stringify(jsonData);
		}

		return jsonData;
	}

	public getPropertyValue<T, K extends keyof T>(data: T, key: K) {
		return data[key];
	}

	protected resetTrackChanges() {
		this.toJson();
	}

	protected omitKeys(obj: any, keys: any) {
		if (typeof obj !== "object" || obj === null || Array.isArray(obj)) {
			return obj;
		}

		const dup: any = {};
		for (const key in obj) {
			if (keys.indexOf(key) === -1) {
				dup[key] = this.omitKeys(obj[key], keys);
			}
		}
		return dup;
	}
}
